export default {
  create: {
    success: 'Destinataire créé avec succès',
    error: 'Impossible de créer ce destinataire'
  },
  delete: {
    success: 'Les destinataires ont été supprimés avec succès',
    error: 'Impossible de supprimer les destinataires'
  },
  update: {
    success: 'Destinataire mis à jour avec succès',
    error: 'Impossible de mettre à jour ce destinataire'
  }
}
